import styled from 'styled-components';

export const InfoWindowBody = styled.div`
	padding: 5px 30px;
`;

export const InfoWindowIcon = styled.div`
	color: #6860e4;
	text-align: center;
	font-family: 'Font Awesome 6 Pro';
	font-size: 70px;
	font-style: normal;
	font-weight: 400;
	line-height: 21px;
	margin-bottom: 28px;
`;

export const InfoWindowIconDescription = styled.div`
	color: #31363a;
	text-align: center;
	font-size: 18px;
	font-weight: bold;
	line-height: 26px;
`;

export const InfoWindowTopicTitle = styled.h6`
	color: #5341c6;
	font-size: 15px;
	margin-top: 21px;
`;

export const InfoWindowTopicBody = styled.p`
	color: #101828;
	font-size: 11px;
	line-height: 21px;
`;

export const SelectAllCheck = styled.div`
	height: 40px;
	margin: 2px;
	padding-right: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 11px;
	font-weight: 500;
	line-height: 11px;
	text-align: left;

	.p-checkbox {
		margin-right: 9px;
	}
`;
